import { Link } from "react-router-dom";
import ExtractIcon from "../../../assets/extracBlackIcon.svg";
import TerminalAutomatic from "../../../assets/terminalAutomaticIcon.svg";

export function Machine() {
	return (
		<div className="flex flex-col machine-card">
			<h6 className="title-text font-bold full-hd:mb-2 qhd:mb-4 qhd-plus:mb-4 4k:mb-5 5k:mb-5">
				Maquininha
			</h6>
			<div className="gap-machine border-radius-container h-full w-full flex flex-col items-center justify-center bg-[#FBFAFA] border border-[#818181] shadow-md">
				<Link
					to={"/maquininha/my-terminals"}
					className="flex ml-[50%] items-center w-full machine-items-gap"
				>
					<img className="icon-machine" src={TerminalAutomatic} alt="" />
					<span className="machine-text">Terminais</span>
				</Link>
				<hr className="border-machine" />
				<Link
					to={"/maquininha/extract"}
					className="flex ml-[50%] items-center w-full machine-items-gap"
				>
					<img className="icon-machine" src={ExtractIcon} alt="" />
					<span className="machine-text">Extrato</span>
				</Link>
			</div>
		</div>
	);
}
